import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  Component,
  ElementRef,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
} from "@angular/core";

import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { GoldenLayout } from "app/golden-layout/golden-layout";
import { Subscription, fromEvent } from "rxjs";

const FADE_IN_TIMEOUT = 5000;

@Component({
  selector: "oms-platform-orders",
  templateUrl: "./oms-platform-orders.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class OmsPlatformOrders implements OnInit, OnDestroy {
  delayFadeIn: boolean = true;

  @ViewChild(GoldenLayout)
  private goldenLayout: GoldenLayout;
  windowPopstateSubscription: Subscription;

  constructor(public element: ElementRef) {
    logger.out.info(`OmsPlatformOrders`);
  }

  ngOnDestroy(): void {
    if (this.windowPopstateSubscription != null) {
      this.windowPopstateSubscription.unsubscribe();
      this.windowPopstateSubscription = null;
    }
  }

  ngOnInit() {
    NativeDesktopSupport.onApplicationInitialized(this.element.nativeElement);

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      Promise.race([
        NativeDesktopSupport.nativeWindowFadeIn,
        new Promise<void>((res) => {
          setTimeout(() => {
            res();
          }, FADE_IN_TIMEOUT);
        }),
      ]).then(() => {
        requestAnimationFrame(() => {
          this.delayFadeIn = false;
        });
      });
    } else {
      this.delayFadeIn = false;
    }

    try {
      history.pushState(null, "OMS");

      this.windowPopstateSubscription = fromEvent(window, "popstate").subscribe((_) => {
        history.pushState(null, "OMS");
      });
    } catch (e) {
      logger.out.error(e);
    }
  }

  public handleAlertChange(event) {
    logger.out.info(`Current alert state = ${event}`);
    // this.goldenLayout.onResize(null);
  }
}
